<button
  class="flex flex-col justify-center items-center bg-neutrals-200 rounded-[8px] p-[2px] box-border h-6 w-6"
  [matMenuTriggerFor]="verticalMenu"
  (click)="stopPropagation($event)"
>
  <div class="block h-4 w-4 overflow-hidden">
    <ui-icon name="vertical-menu" fill="neutrals-600" m-size="16" size="16" />
  </div>
</button>

<mat-menu #verticalMenu="matMenu" class="bg-white">
  <div class="menu-item-grid grid grid-flow-row w-[172px] box-border">
    <button mat-menu-item (click)="executeAction('see-details')">
      <ui-paragraph
        class="capitalize"
        type="p12"
        mobile-type="p12"
        text-color="neutrals-700"
        font-weight="regular"
      >
        Ver detalle
      </ui-paragraph>
    </button>

    <!-- <button mat-menu-item [matMenuTriggerFor]="probabilityMenu">
      <ui-paragraph
        type="p12"
        mobile-type="p12"
        text-color="neutrals-700"
        font-weight="regular"
      >
        Probabilidad
      </ui-paragraph>
    </button> -->

    <button mat-menu-item (click)="executeAction('recurrent-client')">
      <div class="flex justify-between items-center">
        <ui-paragraph
          class="capitalize"
          type="p12"
          mobile-type="p12"
          text-color="neutrals-700"
          font-weight="regular"
        >
          Cliente recurrente
        </ui-paragraph>
        <!--ui-icon name="check-filled" fill="success-300" size="20" mSize="20" /-->
      </div>
    </button>
  </div>
</mat-menu>

<!-- <mat-menu #probabilityMenu="matMenu" class="bg-white">
  <div class="menu-item-grid grid grid-flow-row w-[172px] box-border">
    <button
      mat-menu-item
      class="grid grid-flow-col items-center justify-start"
      (click)="updateClosingProbability.emit(3)"
    >
      <div class="flex justify-between items-center">
        <ui-paragraph
          class="capitalize"
          type="p12"
          mobile-type="p12"
          text-color="neutrals-700"
          font-weight="regular"
        >
          Muy Alta
        </ui-paragraph>
        <ui-icon
          name="check-filled"
          fill="success-300"
          size="20"
          mSize="20"
          *ngIf="closingProbability === 3"
        />
      </div>
    </button>
    <button
      mat-menu-item
      class="grid grid-flow-col items-center justify-start"
      (click)="updateClosingProbability.emit(2)"
    >
      <div class="flex justify-between items-center">
        <ui-paragraph
          class="capitalize"
          type="p12"
          mobile-type="p12"
          text-color="neutrals-700"
          font-weight="regular"
        >
          Alta
        </ui-paragraph>
        <ui-icon
          name="check-filled"
          fill="success-300"
          size="20"
          mSize="20"
          *ngIf="closingProbability === 2"
        />
      </div>
    </button>
    <button
      mat-menu-item
      class="grid grid-flow-col items-center justify-start"
      (click)="updateClosingProbability.emit(1)"
    >
      <div class="flex justify-between items-center">
        <ui-paragraph
          class="capitalize"
          type="p12"
          mobile-type="p12"
          text-color="neutrals-700"
          font-weight="regular"
        >
          Regular
        </ui-paragraph>
        <ui-icon
          name="check-filled"
          fill="success-300"
          size="20"
          mSize="20"
          *ngIf="closingProbability === 1"
        />
      </div>
    </button>
  </div>
</mat-menu> -->
